import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { useExtendedShownMutation } from '@/api/queries/user';
import { H1, StringSmall } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';
import { Picture } from '@/components/ui/Picture/Picture';
import { setCurrencyExchangedShown } from '@/redux/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

import { ModalContext } from '../Modal/config';

import css from './style.module.scss';

import toncoinPng from '/img/icons/toncoin-large.png';
import toncoinWebp from '/img/icons/toncoin-large.webp';
import usdPng from '/img/icons/usd-large.png';
import usdWebp from '/img/icons/usd-large.webp';

const WithDrawInfo: React.FC = () => {
  const [shown] = useExtendedShownMutation();
  const { t } = useTranslation();
  const tonsPerUsdt = useAppSelector(
    (state) => state.user.extendedInfo?.exchangeRate?.tonsPerUsd,
  );
  const dispatch = useAppDispatch();
  const { closeModal } = useContext(ModalContext);

  return (
    <>
      <div className="flex items-center gap-4 justify-center">
        <div className="">
          <Picture
            className="block w-12 h-12 shrink-0"
            img={toncoinPng}
            webp={toncoinWebp}
            alt="toncoin"
          />
        </div>
        <div className={css.arrows}>
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className={css.chevron}></div>
          ))}
        </div>
        <div className="">
          <Picture
            className="block w-12 h-12 shrink-0"
            img={usdPng}
            webp={usdWebp}
            alt="toncoin"
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center gap-2 px-4">
        <H1 className="!text-[18px] !font-[700] text-center">
          {t('We’ve updated the format: Your balance is now shown in USD')}
        </H1>
        <StringSmall className="!text-white/40 text-center !leading-[120%]">
          {t(
            'All existing funds as well as future rewards are now displayed in USD',
          )}
        </StringSmall>
      </div>
      <div className="flex flex-col items-center gap-1">
        <StringSmall className="text-center">
          1 USD = {tonsPerUsdt?.toFixed(3)} TON
        </StringSmall>
        <StringSmall className="text-center !text-white/40">
          {t('Current rate')}
        </StringSmall>
      </div>
      <div className="w-full">
        <MainButton
          text="OK"
          onClick={() => {
            shown();
            closeModal();
            dispatch(setCurrencyExchangedShown());
          }}
        ></MainButton>
      </div>
    </>
  );
};

export default WithDrawInfo;
